var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69473 2.60465L8.39973 4.01465C8.49473 4.20965 8.74973 4.39465 8.96473 4.43465L10.2397 4.64465C11.0547 4.77965 11.2447 5.36965 10.6597 5.95965L9.66473 6.95465C9.49973 7.11965 9.40473 7.44465 9.45973 7.67965L9.74473 8.90965C9.96973 9.87965 9.44973 10.2596 8.59473 9.74965L7.39973 9.03965C7.18473 8.90965 6.82473 8.90965 6.60973 9.03965L5.41473 9.74965C4.55973 10.2546 4.03973 9.87965 4.26473 8.90965L4.54973 7.67965C4.59473 7.43965 4.49973 7.11465 4.33473 6.94965L3.33973 5.95465C2.75473 5.36965 2.94473 4.77965 3.75973 4.63965L5.03473 4.42965C5.24973 4.39465 5.50473 4.20465 5.59973 4.00965L6.30473 2.59965C6.68973 1.83965 7.30973 1.83965 7.69473 2.60465Z",
    fill: "url(#paint0_linear_2250_15300)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.875H1C0.795 2.875 0.625 2.705 0.625 2.5C0.625 2.295 0.795 2.125 1 2.125H4C4.205 2.125 4.375 2.295 4.375 2.5C4.375 2.705 4.205 2.875 4 2.875Z",
    fill: "url(#paint1_linear_2250_15300)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.875H1C0.795 9.875 0.625 9.705 0.625 9.5C0.625 9.295 0.795 9.125 1 9.125H2.5C2.705 9.125 2.875 9.295 2.875 9.5C2.875 9.705 2.705 9.875 2.5 9.875Z",
    fill: "url(#paint2_linear_2250_15300)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.375H1C0.795 6.375 0.625 6.205 0.625 6C0.625 5.795 0.795 5.625 1 5.625H1.5C1.705 5.625 1.875 5.795 1.875 6C1.875 6.205 1.705 6.375 1.5 6.375Z",
    fill: "url(#paint3_linear_2250_15300)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2250_15300",
    x1: 10.3275,
    y1: 6.00337,
    x2: 4.27991,
    y2: 6.00337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED499C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E53F58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2250_15300",
    x1: 4.06,
    y1: 2.5,
    x2: 1.225,
    y2: 2.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED499C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E53F58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2250_15300",
    x1: 2.686,
    y1: 9.5,
    x2: 0.985,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED499C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E53F58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2250_15300",
    x1: 1.77,
    y1: 6,
    x2: 0.825,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED499C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E53F58"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStar);
export default __webpack_public_path__ + "static/media/ic-star.3d9dfce21b039f3352ae7996caa20747.svg";
export { ForwardRef as ReactComponent };